"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const lodash_1 = require("lodash");
const material_1 = require("@mui/material");
const ActionsMenu = ({ anchorEl = null, handleClose, menuItems, open, ...menuProps }) => (react_1.default.createElement(material_1.Menu, { anchorEl: anchorEl, keepMounted: true, open: open || false, onClose: handleClose, ...menuProps }, menuItems.map(({ label, onClick, ...menuItemProps }) => (react_1.default.createElement(material_1.MenuItem, { key: (0, lodash_1.kebabCase)(label), onClick: onClick, ...menuItemProps }, label)))));
exports.default = ActionsMenu;
